<template>
    <div class="preView">预留</div>
</template>
<script>
export default {

};
</script>
<style scoped>
.preView {
    line-height: 330px;
    text-align: center;
}
</style>
